import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export interface GainFieldsVisibility {
  energyType: boolean;
  energyAmount: boolean;
  refrigerantType: boolean;
  co2Amount: boolean;
}

export type GainFieldsVisibilityResolver = (gain: AbstractControl) => GainFieldsVisibility;

interface GainFieldPair {
  categoryVisible: boolean;
  categoryValue: unknown;
  amountVisible: boolean;
  amountValue: unknown;
}

function isFilled(value: unknown): boolean {
  return value !== null && value !== undefined && value !== '' && value !== 0;
}

export function gainValidator(resolveVisibility?: GainFieldsVisibilityResolver): ValidatorFn {
  return (gain: AbstractControl): ValidationErrors | null => {
    if (!resolveVisibility) {
      return null;
    }

    const visibility = resolveVisibility(gain);

    const pairs: GainFieldPair[] = [
      {
        categoryVisible: visibility.energyType,
        categoryValue: gain.get('energy_type_id')?.value,
        amountVisible: visibility.energyAmount,
        amountValue: gain.get('theoretical_savings_full_year')?.value,
      },
      {
        categoryVisible: visibility.refrigerantType,
        categoryValue: gain.get('refrigerant_type_id')?.value,
        amountVisible: visibility.co2Amount,
        amountValue: gain.get('theoretical_greenhouse_gas_savings_full_year')?.value,
      },
    ];

    for (const pair of pairs) {
      const hasCategory = pair.categoryVisible && isFilled(pair.categoryValue);
      const hasAmount = pair.amountVisible && isFilled(pair.amountValue);

      if (hasCategory && pair.amountVisible && !hasAmount) {
        return { gainValueRequired: { required: true } };
      }
      if (hasAmount && pair.categoryVisible && !hasCategory) {
        return { energyOrRefrigerant: { required: true } };
      }
    }

    return null;
  };
}
